import moment from "moment";
import { useRef } from "react";

import useInterval from "../useInterval";

function useMomentRef() {
  const momentRef = useRef<moment.Moment | null>(null);

  function getMoment(): moment.Moment {
    if (momentRef.current === null) momentRef.current = moment();
    return momentRef.current;
  }

  function setMoment(newMoment: moment.Moment) {
    momentRef.current = newMoment;
  }

  return {
    getMoment,
    setMoment
  };
}

export function useMoment(): moment.Moment {
  const { getMoment } = useMomentRef();
  return getMoment();
}

export function useMomentUpdatingAtInterval(intervalDurationSeconds: number) {
  const { getMoment, setMoment } = useMomentRef();
  const intervalDurationMs = intervalDurationSeconds * 1000;
  useInterval(() => {
    setMoment(moment());
  }, intervalDurationMs);

  return getMoment();
}

export function useMomentUpdatingEveryMinute() {
  return useMomentUpdatingAtInterval(60);
}
